import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

const SectionCoreService = () => {
  const { t } = useTranslation();
  const [hoverColors, setHoverColors] = useState<Record<number, string>>({});
  const colorPool = ['#D7D3F7', '#05C0FF', '#55DB9C', '#7A69FA'];

  const handleMouseEnter = (index: number) => {
    const randomColor = colorPool[Math.floor(Math.random() * colorPool.length)];
    setHoverColors((prev) => ({ ...prev, [index]: randomColor }));
  };

  const handleMouseLeave = (index: number) => {
    setHoverColors((prev) => {
      const newColors = { ...prev };
      delete newColors[index];
      return newColors;
    });
  };
  const solutions = [
    t('Consulting'),
    t('White Label Services'),
    t('Custom Development'),
    t('System Integration'),
    t('Maintenance Support'),
    t('Technical Training'),
    t('Security Audits'),
    t('Offshore Development Centers'),
    t('Startup Support Services'),
    t('MVP Development Support'),
    t('Custom Token Solutions'),
  ];
  return (
    <section className="solution">
      <div className="title-section">
        <p className="title">{t('We Serve For')}</p>
        <span className="tag">(12)</span>
      </div>
      <div className="layout-grid">
        {solutions.map((item, index) => (
          <div
            key={index}
            className="grid-item"
            onMouseEnter={() => handleMouseEnter(index)}
            onMouseLeave={() => handleMouseLeave(index)}
            style={hoverColors[index] ? { backgroundColor: hoverColors[index] } : {}}
          >
            {item}
          </div>
        ))}
      </div>
    </section>
  );
};

export default React.memo(SectionCoreService);
